import Vue from 'vue';
import checklistDB from '@mobile/db/checklists';

export default {
    namespaced: true,

    state: getDefaultState(),

    getters: {
        all: (state) => state.checklists,
    },

    actions: {
        async updateAll({ dispatch }, progress) {

            // this needs to work offline, so we don't care about connection problems, or even server errors
            // we ignore everything
            try {
                await checklistDB.updateAll(progress);
            } catch (error) {}

            await dispatch('loadFromDB');
        },
        async loadFromDB({ state }) {
            const checklists = await checklistDB.getAll();
            state.checklists = checklists;
        },
        async searchByTitle({ state }, searchString) {
            const allChecklists = await checklistDB.getAll();
            if (!searchString) {
                state.checklists = allChecklists;
                return;
            }
            const matchingChecklist = [];
            const lowercaseSearchString = searchString.toLowerCase();
            for (let i = 0; i < allChecklists.length; i++) {
                if (allChecklists[i].title.toLowerCase().search(lowercaseSearchString) !== -1) {
                    matchingChecklist.push(allChecklists[i]);
                }
            }

            state.checklists = matchingChecklist;
        },
    },

    mutations: {

        reset(state) {
            Object.assign(state, getDefaultState());
        },

    },

};

function getDefaultState() {
    return {
        checklists: [],
    };
}
